import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../../../../../common/authorization/AuthorizeService";
import { Column } from "../../../../../common/columns";
import { cutShort } from "../../../../../utils/stringUtil";

function RequestDetails(docState) {
  const { t } = useTranslation();
  const [acceptanceInfo, setAcceptanceInfo] = useState({
    text: "",
    disabled: false,
  });

  const stateHandler = useCallback(() => {
    if (docState.docState.doc.color === "red") {
      return <p className="has-text-danger">{t("requests.documentAcceptance.sentBack")}</p>;
    } else if (docState.docState.doc.color === "green") {
      return <p className="has-text-success">{t("requests.documentAcceptance.accepted")}</p>;
    }
  }, [t, docState]);

  useEffect(() => {
    setAcceptanceInfo({ text: stateHandler() });
  }, [docState.doc, stateHandler]);

  return (
    <Column className="is-centered is-one-fifth">
      <div className="block mx-4">
        <p>{docState.docState.state.request.pdfFormName}</p>
        <p>
          {t("requests.documentAcceptance.subject")}
          {docState.docState.state.request.subject}
        </p>
        <p>
          {t("requests.documentAcceptance.registryNumber")}
          {docState.docState.state.request.registryNumber}
        </p>
        {acceptanceInfo.text}
        <p>{docState.docState.state.request.info}</p>
        {/* {
          <button
            target="_blank"
            className={"button is-light has-background-white-ter has-text-weight-bold is-size-7"}
            rel="noopener noreferrer"
            onClick={async () =>
              fetch(`${process.env.REACT_APP_GATEWAY_URL}${docState.docState.doc.href}`, {
                method: "GET",
                headers: {
                  "Request-Origin": "pisarnica",
                  Authorization: "Bearer " + (await getAccessToken()),
                },
                mode: "cors",
                credentials: "include",
              })
                .then((response) => response.blob())
                .then((file) => window.open(URL.createObjectURL(file)))
            }
          >
            {t("requests.decisionAcceptance.stampInfo")}
          </button>
        } */}
      </div>
    </Column>
  );
}

export default RequestDetails;
